var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2041",
    "data-name": "Rectangle 2041",
    width: 10,
    height: 14,
    fill: "#00c22d",
    stroke: "#00c22d",
    strokeWidth: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12746",
    "data-name": "Group 12746",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12745",
    "data-name": "Group 12745",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12691",
    "data-name": "Path 12691",
    d: "M4.959,0A4.81,4.81,0,0,1,7.147.5a4.756,4.756,0,0,1,1.374.977,4.962,4.962,0,0,1,1.284,2.24,9.984,9.984,0,0,1,.167,1.04,4.5,4.5,0,0,1-.485,2.363,15.327,15.327,0,0,1-.86,1.77c-.534.923-1.107,1.826-1.687,2.725-.384.6-.805,1.172-1.215,1.753a5.333,5.333,0,0,1-.364.462.5.5,0,0,1-.785-.044c-.863-1.13-1.657-2.3-2.408-3.5A23.355,23.355,0,0,1,.682,7.567,7.561,7.561,0,0,1,.033,5.621a5.1,5.1,0,0,1-.005-1.1A4.7,4.7,0,0,1,.585,2.684,4.923,4.923,0,0,1,1.317,1.64a5.058,5.058,0,0,1,1.252-1A4.3,4.3,0,0,1,4.158.079c.266-.034.534-.053.8-.079M5,12.91c.355-.513.7-.985,1.017-1.472.538-.828,1.075-1.657,1.578-2.5a18.78,18.78,0,0,0,.926-1.78,4.429,4.429,0,0,0,.571-2.387,6.113,6.113,0,0,0-.19-1.02,4.082,4.082,0,0,0-.926-1.592,4.211,4.211,0,0,0-1.085-.846A3.971,3.971,0,0,0,4.846.838a3.882,3.882,0,0,0-1.512.345A4.062,4.062,0,0,0,1.948,2.228a4.182,4.182,0,0,0-.633.945A4.409,4.409,0,0,0,.9,4.626a3.154,3.154,0,0,0,.047,1.1,6.959,6.959,0,0,0,.3.921A18.644,18.644,0,0,0,2.889,9.785c.555.877,1.149,1.731,1.728,2.6.115.171.242.335.384.53",
    transform: "translate(0 0)",
    fill: "#00c22d",
    stroke: "#00c22d",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12692",
    "data-name": "Path 12692",
    d: "M7.081,4.657a2.173,2.173,0,0,1-2.3,2.119,2.169,2.169,0,0,1-2.23-2.119A2.189,2.189,0,0,1,4.971,2.545a2.165,2.165,0,0,1,2.11,2.112m-3.631,0A1.378,1.378,0,0,0,6.2,4.593,1.34,1.34,0,0,0,4.758,3.368,1.316,1.316,0,0,0,3.45,4.654",
    transform: "translate(0.17 -0.01)",
    fill: "#00c22d",
    stroke: "#00c22d",
    strokeWidth: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c3b8ba2a4f5ba73811997aee96fdfb19.svg";
export { ForwardRef as ReactComponent };